export enum RoutesEnum {

  // Auth
  onboarding = '/onboarding',
  login = 'login',
  register = 'register',
  forgetPass = 'forget-pass',

  // Core
  home = '/app/tabs/home',
  modules = '/app/tabs/modules',

  // Purchases
  products = '/app/tabs/products',
  productDetail = '/app/product/',
  productStore = '/app/product-store',
  productProviderStore = '/app/product-provider-store',
  providers = '/app/tabs/providers',
  providerDetail = '/app/provider/',
  providerStore = '/app/provider-store',
  providerContactStore = '/app/provider-contact-store',
  providerProductStore = '/app/provider-product-store',
  orders = '/app/tabs/orders',
  orderDetail = '/app/order/',
  orderStore = '/app/order-store',
  deliveryNotes = '/app/tabs/delivery-notes',
  deliveryNoteDetail = '/app/delivery-note/',
  deliveryNoteStore = '/app/delivery-note-store',

  // RRHH
  folders = '/app/tabs/folders',
  folderDetail = '/app/tabs/folders/detail',
  fileStore = '/app/file-store',
  holidays = '/app/tabs/holidays',
  holidayStore = '/app/holiday-store',
  publicHolidays = '/app/tabs/public-holidays',
  clockIn = '/app/tabs/clock-in-list',
  clockInStore = '/app/clock-in-store',
  schedules = '/app/tabs/schedules',
  scheduleStore = '/app/schedule-store',
  requests = 'app/tabs/requests',
  requestsStore = '/app/requests-store',
  users = '/app/tabs/users',
  userDetail = '/app/users/',
  usersStore = '/app/users-store',

  // Finances
  cashClosing = '/app/tabs/cash-closing',
  cashClosingDetail = '/app/cash-closing/',
  cashClosingStore = '/app/cash-closing-store',
  payments = '/app/tabs/payments',
  ebitda = '/app/tabs/ebitda',
  ebitdaDetail = '/app/ebitda-detail',
  expenses = '/app/tabs/expenses',
  expenseDetail = '/app/expense-detail',
  generalExpenseStore = '/app/general-expenses-store',
  personalExpenseStore = '/app/personal-expenses-store',

  // YuChef
  elaborations = '/app/tabs/elaborations',
  elaborationDetail = '/app/elaboration/',
  elaborationStore = '/app/elaboration-store',
  elaborationStepStore = '/app/elaboration-step-store',
  recipesCosting = '/app/tabs/recipes-costing',
  recipeCostingDetail = '/app/recipe-costing/',
  recipeCostingStore = '/app/recipe-costing-store',
  recipeCostingStepStore = '/app/recipe-costing-step-store',
  recipeCostingIngredientStore = '/app/recipe-costing-ingredient-store',
  recipes = '/app/tabs/recipes',
  recipeDetail = '/app/recipe/',
  recipeStore = '/app/recipe-store',
  recipeStepStore = '/app/recipe-step-store',
  recipeIngredientStore = '/app/recipe-ingredient-store',
  recipeResultStore = '/app/recipe-result-store',
  labeled = '/app/tabs/labeled',
  labeledStore = '/app/labeled-store',
  miseEnPlace = '/app/tabs/mise-en-place',

  // Communication
  communication = '/app/tabs/communication',
  communicationDetail = '/app/communication/',
  communicationStore = '/app/communication-store',
  breakdownBudgetStore = '/app/breakdown-budget-store',

  // Warehouse
  wastage = '/app/tabs/wastages',
  wastageStore = 'app/wastages-store',
  operations = 'app/tabs/operations',
  operationInventory = 'app/operation/inventory/',
  operationRevision = 'app/operation/revision/',
  operationReload = 'app/operation/reload/',
  transfers = '/app/tabs/transfers',
  transferStore = 'app/transfer-store',
  transferDetail = 'app/transfer/',
  transferProductStore = 'app/transfer-product-store',
  stocks = '/app/tabs/stocks',
  stocksProductStore = '/app/stocks-product-store',
  minMaxStore = 'app/min-max-store',
  transferStock = '/app/transfer-stock',
  inventoryStock = '/app/inventory-stock',

  // Tasks
  tasks = 'app/tabs/tasks',
  taskDetail = 'app/task/',
  taskStore = 'app/task-store',
  imageReviewer = 'app/image-reviewer',
  models = 'app/tabs/models',
  modelStore = 'app/model-store',
  modelDetail = 'app/model/',
  fieldStore = 'app/field-store',
  schedulesChecklist = 'app/tabs/schedules-checklist',
  schedulesChecklistStore = 'app/schedules-checklist-store',
  schedulesAppcc = 'app/tabs/schedules-appcc',
  schedulesAppccStore = 'app/schedules-appcc-store',
  checkpoints = 'app/tabs/checkpoints',
  machineDetail = 'app/machine/',
  machineAppccStore = 'app/machine-appcc-store',
  productAppccStore = 'app/product-appcc-store',
  providerAppccStore = 'app/provider-appcc-store',

  // Notifications
  notifications = '/app/notifications',
  notificationsConfig = '/app/notifications-config',

  // Reports
  productPurchasesReport = 'app/tabs/product-purchases-report',
  providerPurchasesReport = 'app/tabs/provider-purchases-report',
  checklistsReport = 'app/tabs/checklists-report',
  auditsReport = 'app/tabs/audit-report',
  appccsReport = 'app/tabs/appcc-report',
  clockInReport = 'app/tabs/clock-in-report',
  clockInDetailReport = 'app/clock-in-detail-report',

  // Dashboards
  dashboards = 'app/tabs/dashboard',

  // Events
  events = 'app/tabs/events',
  eventDetail = 'app/event/',
  inventoryEvent = 'app/inventory-event/',

  // Documents Review
  documentsReview = '/app/tabs/documents-review',
  deliveryNoteReview = '/app/delivery-note-review/',
  expenseReview = '/app/expense-review',
  payrollReview = '/app/payroll-review',
  unclassifiedReview = '/app/unclassified-review',

  // Configuration
  profile = '/app/tabs/modules/profile',
  editUser = '/app/edit-profile',
  editPassword = '/app/edit-password',
  editPin = '/app/edit-pin',
  locals = '/app/tabs/locals',
  devices = '/app/tabs/devices',
  devicesStore = '/app/devices-store',

}
